import { useActiveRoles, hasRole, hasAtLeastOneRole, } from "../utils/permissionsUtils";
import { RoleEnum } from "../types/RoleEnum";
export var usePermissions = function () {
    var activeRoles = useActiveRoles().roles;
    var checkRoles = function () {
        var roles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            roles[_i] = arguments[_i];
        }
        return hasRole(activeRoles, RoleEnum.SUPERUSER) ||
            roles.some(function (role) { return hasRole(activeRoles, role); });
    };
    return {
        // Publisher management permissions
        canViewPublishers: checkRoles(RoleEnum.AGENCY_WORKER),
        canCreatePublisher: checkRoles(RoleEnum.AGENCY_WORKER),
        canEditPublisher: checkRoles(RoleEnum.AGENCY_WORKER),
        canClosePublisher: checkRoles(RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN),
        canApprovePublisher: checkRoles(RoleEnum.AGENCY_WORKER),
        canRestorePublisher: checkRoles(RoleEnum.AGENCY_WORKER),
        canTakeOverPublisher: checkRoles(RoleEnum.AGENCY_WORKER),
        // Publisher-side roles cannot read users outside their own organization
        // (mod-br-users returns 403), so the editor name is agency-only.
        canViewPublisherEditor: checkRoles(RoleEnum.AGENCY_WORKER),
        // My Publisher permissions
        canViewMyPublisher: checkRoles(RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR),
        canEditMyPublisher: checkRoles(RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR),
        canConfirmMyPublisherData: checkRoles(RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR),
        // ARES Updates permissions
        canViewAresUpdates: checkRoles(RoleEnum.AGENCY_WORKER),
        canEditAresUpdates: checkRoles(RoleEnum.AGENCY_WORKER),
        // Publisher registrations permissions
        canViewPublisherRegistrations: checkRoles(RoleEnum.AGENCY_WORKER),
        canApprovePublisherRegistration: checkRoles(RoleEnum.AGENCY_WORKER),
        canManagePublisherRegistrations: checkRoles(RoleEnum.AGENCY_WORKER),
        // DB-898: the publisher admin converts the own publisher's one-off
        // registration to continuous in "Můj nakladatel" (not a guarantor).
        canConvertOwnPublisherRegistration: checkRoles(RoleEnum.PUBLISHER_ADMIN),
        canAddPublisherRegistration: checkRoles(RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN),
        // Publisher updates permissions
        canViewPublisherUpdates: checkRoles(RoleEnum.AGENCY_WORKER),
        canApprovePublisherUpdate: checkRoles(RoleEnum.AGENCY_WORKER),
        // Admin permissions
        canViewAdmin: checkRoles(RoleEnum.SUPERUSER),
        // Role flags
        isSuperUser: hasRole(activeRoles, RoleEnum.SUPERUSER),
        isAgencyWorker: hasRole(activeRoles, RoleEnum.AGENCY_WORKER),
        isPublisherGuarantor: hasRole(activeRoles, RoleEnum.PUBLISHER_GUARANTOR),
        isPublisherAdmin: hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN),
        isPublisher: hasAtLeastOneRole(activeRoles, [
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.PUBLISHER_GUARANTOR,
        ]),
        // Helper functions
        hasRole: function (role) {
            return checkRoles(role);
        },
        hasAnyRole: function (roles) {
            return checkRoles.apply(void 0, roles);
        },
    };
};
